import React from "react";

export const getRugbyHalves = (matchData) => {
  if (!matchData) {
    return [];
  }

  return [
    {
      title: "1st Half",
      score: matchData?.first_half_score ?? "",
      events:
        matchData?.first_half_events ||
        matchData?.events?.first_half_events ||
        [],
    },
    {
      title: "2nd Half",
      score: matchData?.second_half_score ?? "",
      events:
        matchData?.second_half_events ||
        matchData?.events?.second_half_events ||
        [],
    },
  ];
}